if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initNotifiers();

        window.BOLD &&
          BOLD.common?.eventEmitter?.on('BOLD_OPTIONS_option_products_loaded', () => {
            const btns = this.querySelectorAll('[type="submit"]');
            this.submitButton = btns.length > 1 ? btns[btns.length - 1] : this.submitButton;
            this.submitButtonText = this.submitButton.querySelector('span');
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          if (this.notifier) {
            this.submitButton.classList.add('hidden');
            this.notifier.classList.remove('hidden');
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = this.submitButtonText.dataset.addText ?? window.variantStrings.addToCart;
          if (this.notifier) {
            this.notifier.classList.add('hidden');
            this.submitButton.classList.remove('hidden');
          }
        }
      }

      initNotifiers() {
        this.notifier = this.querySelector('.product-form__drop-notify');
        if (this.notifier) {
          this.notifier.addEventListener('click', this.onDropNotify.bind(this));
        } else {
          this.notifier = this.querySelector('.pf__bis-opener');
          if (this.notifier) {
            this.backInStockForm = document.querySelector(this.notifier.dataset.form);
            this.backInStockModal = document.querySelector(this.notifier.dataset.modal);
            this.backInStockForm.addEventListener('submit', this.onBackInStockSubmit.bind(this));
            this.backInStockForm.querySelector('input').addEventListener('input', this.bisDisableToggle.bind(this));
            this.backInStockModal.addEventListener('opened', this.bisOnModalOpen.bind(this));
          }
        }
      }

      onDropNotify(evt) {
        evt.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'T2a72D']);
      }

      async onBackInStockSubmit(evt) {
        evt.preventDefault();
        const formMessage = this.backInStockModal.querySelector('.form__message');
        formMessage.classList.add('hidden');
        try {
          const productFormData = new FormData(this.form);
          const formData = new FormData(this.backInStockForm);
          this.backInStockForm.bis_submit.disabled = true;
          const response = await fetch(window.routes.app + '/stock-notifications', {
            method: 'POST',
            body: JSON.stringify({
              requestType: 'variant_stock_notification',
              email: formData.get('notification_email'),
              id: '',
              productId: formData.get('product_id'),
              variantId: productFormData.get('id'),
            }),
            headers: { 'content-type': 'application/json' },
          });
          const json = await response.json();
          if (response.ok || response.status === 409) {
            this.backInStockForm.classList.add('hidden');
            this.backInStockModal.querySelector('.notify-subtext').classList.add('hidden');
            const messageEl = this.backInStockModal.querySelector('.success-message');
            messageEl.querySelector('.message').innerHTML =
              json.subscription === 'accepted'
                ? 'Check your email to confirm your subscription. Once confirmed we will notify you as soon as this product is back on the shelf.'
                : 'You are all set to be notified as soon as this product is back on the shelf.';
            messageEl.classList.remove('hidden');
          } else {
            this.bisHandleError(formMessage, json?.error?.email?.[0]);
          }
        } catch (err) {
          this.bisHandleError(formMessage);
        } finally {
          this.backInStockForm.bis_submit.disabled = false;
        }
      }

      bisHandleError(formMessage, text) {
        formMessage.querySelector('.message').innerHTML =
          text ?? 'There was an error submitting your email, please try again.';
        formMessage.classList.remove('hidden');
      }

      bisDisableToggle(evt) {
        const empty = evt.target.value.trim() === '';
        const submitter = this.backInStockForm.bis_submit;
        if (empty && !submitter.disabled) {
          submitter.disabled = true;
          submitter.setAttribute('aria-disabled', true);
        } else if (!empty && submitter.disabled) {
          submitter.disabled = false;
          submitter.setAttribute('aria-disabled', false);
        }
      }

      bisOnModalOpen() {
        if (this.backInStockForm.classList.contains('hidden')) {
          this.backInStockModal.querySelector('.notify-subtext').classList.remove('hidden');
          this.backInStockModal.querySelector('.success-message').classList.add('hidden');
          this.backInStockForm.classList.remove('hidden');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
